export enum MarketingChannel {
	Any = 'Any',
	Email = 'Email',
	Letter = 'Letter',
	Sms = 'Sms',
	Phone = 'Phone',
}
